"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDefined;
/**
 * Check if a value is defined
 * @ignore
 * @param {*} value
 * @return {boolean}
 */

function isDefined(value) {
  return value !== undefined && value !== null;
}

module.exports = exports["default"];